import React, {FC, useState, useEffect} from 'react'
import {useFormContext} from 'react-hook-form'
import {
  SelectWrapper,
  InputTextWrapper,
  InputNumberWrapper,
} from '../../../../../../components/UI/Form/Input'
import {getDepartment, getSiteById} from '../../../../services'
import {SiteModel, LocationModel} from '../../../../model'
import {useCentral} from '../../../../../../hooks/useCentral'
import {useCompany, useClient, useProvince, useDistrict, useUser} from '../../../../hooks'
import {initValues} from '../../../../util/values/site'
import AditionalForm from '../../../../../../components/UI/Form/aditionalCamp/aditionalCampCentral'
import ContentForm from '../../../../../../components/UI/Form/contentForm'
import {TITLE_FORM_SITE} from '../../../../util/Constants'
import useTableForMaster from '../../../../hooks/useTableForMaster'
import {CheckWrapper} from '../../../../../../components/UI/Form/Input'

const valuesHote = [
  {
    value: true,
    label: 'SI',
  },
  {
    value: false,
    label: 'NO',
  },
]
const Index: FC = () => {
  const {setValue} = useFormContext()
  const {currentTabItem} = useCentral()
  const {companyList, getCompanyList} = useCompany()
  const {clientList, getClientList} = useClient()
  const {province, getProvince1, handleClearProvince} = useProvince()
  const {district, getDistrict1, handleClearDistrict} = useDistrict()
  const {userList, getUserList, getUserData} = useUser()
  const {docType, getDocTypeList} = useTableForMaster()
  const [department, setDepartment] = useState<LocationModel[] | any>([])

  const getUserId = async (idUser: string = '') => {
    const response = await getUserData({id: idUser})
    const data = response[0] || null
    return data
  }

  const getDepartmentList = async () => {
    const response = await getDepartment()
    const data = response.data.data
    const mappedSites = data.map((item) => ({value: item.id, label: item.nombre}))
    setDepartment(mappedSites)
  }

  useEffect(() => {
    getDepartmentList()
    getCompanyList()
    getUserList()
    getDocTypeList()
  }, [])

  const getSiteByIdValues = async () => {
    try {
      const response = await getSiteById(currentTabItem.idToEdit)
      const data = response.data.data
      type SiteModelKeys = keyof SiteModel
      for (const fieldName in initValues) {
        if (initValues.hasOwnProperty(fieldName)) {
          if (data.hasOwnProperty(fieldName)) {
            if (data[fieldName as SiteModelKeys] || fieldName === 'integComensalHuesped') {
              if (fieldName === 'requiereCenso') {
                let valueCenso = data[fieldName as SiteModelKeys]
                if (typeof valueCenso === 'boolean') {
                  setValue('requiereCenso', valueCenso)
                }
              }
              if (fieldName === 'departamentoId') {
                let valueDep = data[fieldName as SiteModelKeys]
                if (typeof valueDep === 'string') {
                  setValue('departamentoId', valueDep)
                  getProvince1(valueDep)
                }
              }
              if (fieldName === 'provinciaId') {
                let valueProv = data[fieldName as SiteModelKeys]
                if (typeof valueProv === 'string') {
                  setValue('provinciaId', valueProv)
                  getDistrict1(valueProv)
                }
              }
              if (fieldName === 'companiaId') {
                let valueComp = data[fieldName as SiteModelKeys]
                if (typeof valueComp === 'string') {
                  setValue('companiaId', valueComp)
                  getClientList({companiaId: valueComp})
                }
              } else if (fieldName === 'interlocutorId') {
                let valueComp = data[fieldName as SiteModelKeys]
                if (typeof valueComp === 'string') {
                  setValue('interlocutorId', valueComp)
                  const filteredData = (await getUserId(valueComp)) || null
                  handleSetValues(filteredData)
                }
              } else if (fieldName === 'campoadicionalFec1') {
                let valueDep = data[fieldName as SiteModelKeys]
                if (valueDep !== null && valueDep !== undefined && typeof valueDep === 'string') {
                  const fechaLocal = new Date(valueDep)
                  const formattedDate = fechaLocal.toISOString().slice(0, 10)
                  setValue(fieldName, formattedDate)
                }
              } else if (fieldName === 'campoadicionalFec2') {
                let valueDep = data[fieldName as SiteModelKeys]
                if (valueDep !== null && valueDep !== undefined && typeof valueDep === 'string') {
                  const fechaLocal = new Date(valueDep)
                  const formattedDate = fechaLocal.toISOString().slice(0, 10)
                  setValue(fieldName, formattedDate)
                }
              } else {
                setValue(fieldName, data[fieldName as SiteModelKeys])
              }
            } else {
              setValue(fieldName, '')
            }
          }
        }
      }
    } catch (error) {
      console.error('Error al obtener la lista de países:', error)
    }
  }
  useEffect(() => {
    if (currentTabItem.idToEdit) {
      getSiteByIdValues()
    }
  }, [currentTabItem.idToEdit])
  let isDisabled = currentTabItem.idToEdit ? true : false
  const handleDepartmentChange = (val: any) => {
    let value = val ? val.value : ''
    handleClearProvince()
    handleClearDistrict()
    getProvince1(value)
  }

  const handleProvinceChange = (val: any) => {
    let value = val ? val.value : ''
    handleClearDistrict()
    getDistrict1(value)
  }
  const handleGetClientList = async (val: any) => {
    let value = val ? val.value : ''
    getClientList({companiaId: value})
  }
  const handleUserChange = (val: any) => {
    let value = val ? val.value : ''
    const filteredData = userList?.filter((user: any) => user.id === value)[0] || null
    handleSetValues(filteredData)
  }

  const handleSetValues = (data: any = {}) => {
    if (data) {
      setValue('TipoDocumento', data.tipoDocumento)
      setValue('NumeroDocumento', data.numeroDocumento)
      setValue('Nombres', `${data.nombres} ${data.apellidos}`)
      setValue('Telefono', data.telefono)
      setValue('Email', data.email)
    }
  }
  return (
    <ContentForm isEdit={isDisabled} title={TITLE_FORM_SITE}>
      <div className='row'>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='Compañía'
            name='companiaId'
            data={companyList}
            disabled={isDisabled}
            onChangeValue={handleGetClientList}
            required
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='Cliente'
            name='clienteId'
            data={clientList}
            disabled={isDisabled}
            required
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <InputTextWrapper
            labelText='Site'
            name='nombre'
            textPlaceholder='Escribe el nombre'
            disabled={isDisabled}
            required
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='Interlocutor'
            name='interlocutorId'
            data={userList}
            disabled={isDisabled}
            onChangeValue={handleUserChange}
          />
        </div>
      </div>
      <div className='row'>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <InputTextWrapper labelText='Tipo de documento' name='TipoDocumento' disabled={true} />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <InputNumberWrapper
            labelText='Número de documento'
            name='NumeroDocumento'
            disabled={true}
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <InputTextWrapper labelText='Nombres' name='Nombres' disabled={true} />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <InputTextWrapper labelText='Telefono' name='Telefono' disabled={true} />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <InputTextWrapper labelText='Email' name='Email' disabled={true} type='email' />
        </div>
      </div>

      <div className='row'>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <InputTextWrapper
            labelText='Dirección'
            name='direccion'
            textPlaceholder='Escribe la dirección'
            type='address'
            required
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='Departamento'
            name='departamentoId'
            data={department}
            disabled={department.length === 0}
            onChangeValue={handleDepartmentChange}
            required
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='Provincia'
            name='provinciaId'
            data={province}
            disabled={province.length === 0}
            onChangeValue={handleProvinceChange}
            required
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='Distrito'
            name='ubigeoId'
            data={district}
            disabled={district.length === 0}
            required
          />
        </div>
      </div>
      <hr className='divider' />
      <div className='row'>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='Integrar Comensales con Hotelería'
            name='integComensalHuesped'
            data={valuesHote}
            required
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='Tipo documento Checkin / Checkout'
            name='tipoDocumentoCheckInCheckOut'
            data={docType}
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3 d-flex align-items-center justify-content-start'>
          <CheckWrapper name='requiereCenso' nameCheck='Requiere Censo' className='h-100' />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3 d-flex align-items-center justify-content-start'>
          <CheckWrapper
            name='comensalFuncionalidadMixta'
            nameCheck='Funcionalidad Mixta Comensales'
            className='h-100'
          />
        </div>
      </div>
      <hr className='divider' />
      <div className='row'>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <InputTextWrapper
            labelText='Referencia 1'
            name='referencia1'
            textPlaceholder='Escribe la referencia'
            required
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <InputTextWrapper
            labelText='Referencia 2'
            name='referencia2'
            textPlaceholder='Escribe la referencia'
          />
        </div>
      </div>
      <hr className='divider' />
      <AditionalForm />
    </ContentForm>
  )
}

export default Index
